import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { FooterNavbarService } from 'services/connectors/footer-navbar.service';
import { NavbarService } from 'services/connectors/navbar.service';

@Component({
    selector: 'tpc-calculator-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit, OnDestroy {
    @Input() isGatePage;

    calculatorName: string;
    categoryName: string;
    isThankYouScreen: boolean;

    private subscription: Subscription;

    constructor(private footerService: FooterNavbarService,
                private navbarService: NavbarService) {
        this.subscription = navbarService.changeCategory$.subscribe((data) => {
            this.categoryName = data.categoryName;
            this.calculatorName = data.calculatorName;
            this.isThankYouScreen = data.isThankYouScreen;
        });
    }

    ngOnInit() {
    }

    prev() {
        this.footerService.prev();
    }

    skip() {
        this.footerService.skip();
    }

    next() {
        this.footerService.next();
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/shared/footer/footer.component.ts